import React from 'react'
import { connect } from 'react-redux'

import AppLoading from 'components/Layout/AppLoading'
import { Text } from 'components/base'
import { getErrorFromLocation } from './utils'
import { selectors as OrganizationsSelectors } from 'data/organizations'
import { selectors as ConfigSelectors } from 'data/config'
import AuthView from './AuthView'

class AuthContainer extends React.Component {
  renderSwitchTeam = () => {
    return (
      <div key="select" className="shade-20 center-text margin-bottom-large">
        Not your team?{' '}
        <Text.ExternalLink
          inline
          href={`${this.props.boardingAppRoot}/organization/select`}
        >
          Join another!
        </Text.ExternalLink>
      </div>
    )
  }

  renderAutoJoin = () => {
    return (
      <div key="auto-join" className="shade-20 center-text">
        If you have an{' '}
        <span className="font-weight-bold">
          {this.props.formattedAuthDomains}
        </span>{' '}
        email address, you can{' '}
        <Text.Action
          inline
          href={`${this.props.boardingAppRoot}/organization/autojoin/${
            this.props.organization.domain
          }`}
        >
          join this organization
        </Text.Action>
      </div>
    )
  }

  render() {
    const { children, organization, hasAutoJoin } = this.props
    if (!organization) {
      return <AppLoading />
    }

    if (organization.get('authMethod') !== 'emailPassword') {
      return (
        <AuthView
          extraControl={this.renderSwitchTeam()}
          outerControl={hasAutoJoin ? this.renderAutoJoin() : null}
        >
          {children}
        </AuthView>
      )
    }
    return (
      <AuthView extraControl={hasAutoJoin ? this.renderAutoJoin() : null}>
        {children}
      </AuthView>
    )
  }
}

const mapStateToProps = state => {
  const organization = OrganizationsSelectors.getOrganization(state)
  return {
    boardingAppRoot: ConfigSelectors.getBoardingAppRoot(state),
    auth: state.auth,
    error:
      state.auth.error ||
      state.auth.renewalError ||
      getErrorFromLocation(window.location),
    organization,
    formattedAuthDomains: (organization.authDomains || '')
      .split(',')
      .map(domain => `@${domain}`)
      .join(', '),
    hasAutoJoin:
      organization.membersCanAutoJoin &&
      organization.authDomains &&
      organization.authDomains.length > 0,
  }
}

export default connect(mapStateToProps)(AuthContainer)
